import service from "../service";

export const getDetailedReportService = (columns, filters) => (
  service('post', `v3/reportes/detallado`, { data: { columns, filters } })
)

export const downloadDetailedReportService = (columns, filters) => (
  service('post', `v3/reportes/detallado/descargar`, {
    responseType: 'blob',
    data: { columns, filters }
  })
)
export const downloadDetailedReportLecarozService = (columns, filters) => (
  service('post', `v3/reportes/detallado/descargarLecaroz`, {
    responseType: 'blob',
    data: { columns, filters }
  })
)

export const downloadDetailedReportBySalepointService = (columns, filters) => (
  service('post', `v3/reportes/detallado/descargarPorSucursal`, {
    responseType: 'blob',
    data: { columns, filters }
  })
)

export const getCatalogsDetailedReportService = (catalog, data) => (
  service('post', `v3/reportes/detallado/catalogos/${catalog}`, { data })
)

export const getNetworkReportService = (data) => (
  service('post', `v3/reportes/red`, { data })
)

export const downloadNetworkReportService = (columns, filters) => (
  service('post', `v3/reportes/red/descargar`, {
    responseType: 'blob',
    data: { columns, filters }
  })
)

export const getTotalReportService = (data) => (
  service('post', `v3/reportes/totales`, { data })
)

export const getDailyTotalReportService = (data) => (
  service('post', `v3/reportes/totalesdiarios`, { data })
)

export const downloadDailyTotalReportService = (data) => (
  service('post', `v3/reportes/totalesdiarios/descargar`, { responseType: 'blob', data })
)


export const getBalanceReportService = (data) => (
  service('post', `v3/reportes/saldo`, { data })
)

export const downloadBalanceReportService = (data) => (
  service('post', `v3/reportes/saldo/descargar`, { responseType: 'blob', data })
)

export const getBinnacleReportService = (data) => (
  service('post', `v3/reportes/bitacora`, { data })
)

export const downloadBinnacleReportService = (columns, filters) => (
  service('post', `v3/reportes/bitacora/descargar`, {
    responseType: 'blob',
    data: { columns, filters }
  })
)

export const getCommerceReportService = (filters) => (
  service('post', `v3/reportes/comercio`, { data: { filters } })
)
export const getAbonosCommerceReportService = (filters) => (
  service('post', `v3/reportes/abonos`, { data: { filters } })
)
export const downloadAbonosCommerceReportService = (filters) => (
  service('post', `v3/reportes/abonos/descargar`, {
    responseType: 'blob',
    data: { filters }
  })
)
export const getLiberacionesCommerceReportService = (filters) => (
  service('post', `v3/reportes/liberaciones`, { data: { filters } })
)
export const downloadLiberacionesCommerceReportService = (filters) => (
  service('post', `v3/reportes/liberaciones/descargar`, {
    responseType: 'blob',
    data: { filters }
  })
)
export const getSearchTxnReportService = (filters) => (
  service('post', `v3/reportes/buscar_txn`, { data: { filters } })
)
export const downloadSearchTxnReportService = (filters) => (
  service('post', `v3/reportes/buscar_txn/descargar`, {
    responseType: 'blob',
    data: { filters }
  })
)

export const getBehaviorReportService = (data) => (
  service('post', `v3/reportes/comportamiento`, { data })
)


// Conciliaciones


export const getProvidersService = (data) => (
  service('post', `v3/reportes/providers`, { data })
)

export const getConciliacionesDiferenciasReportService = (data) => (
  service('post', `v3/reportes/conciliaciondiff`, { data })
)

export const getConciliacionesReportService = (data) => (
  service('post', `v3/reportes/conciliacion`, { data })
)

export const downloadConciliacionesReportService = (data) => (
  service('post', `v3/reportes/conciliacion/descargar`, { responseType: 'blob', data })
)
export const getConciliacionDiariaReportService = (data) => (
  service('post', `v3/reportes/conciliacion/diaria`, { data })
)

export const downloadConciliacionDiariaReportService = (data) => (
  service('post', `v3/reportes/conciliacion/diaria/descargar`, { responseType: 'blob', data })
)

// Conciliaciones history

export const getConciliacionHistoryService = (data) => (
  service('post', `v3/reportes/conciliacion/history`, { data })
)
export const getConciliacionHistoryLogService = (id) => (
  service('get', `v3/reportes/conciliacion/history/${id}`)
)


//layout
export const getReportLayoutService = (report) => (
  service('get', `v3/reportes/platillas/${report}`)
)

export const createReportLayoutService = (report, data) => (
  service('post', `v3/reportes/platillas/${report}`, {
    contentType: "multipart/form-data",
    form: { ...data }
  })
)

export const updateReportLayoutService = (id, data) => (
  service('patch', `v3/reportes/platillas/${id}`, {
    contentType: "multipart/form-data",
    form: { ...data }
  })
)

export const removeReportLayoutService = (id) => (
  service('delete', `v3/reportes/platillas/${id}`)
)